import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { getInvoiceList } from "../../../../redux/invoice/invoiceState";
import { handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { formatDateTimeOrNull } from "utils/index";

const MyInvoiceTable = ({recordList, pagination, doSearch, filters}) => {
  	const {getColumnSearchProps} = ColumnSearchFilter();

  	const columns = [
	    {
	        title: `Invoice #`,
	        dataIndex: 'inv_number',
	        key: 'inv_number',
	        width: '11%', 	        
	        ...getColumnSearchProps('inv_number'),
	        sorter: true, 
	        render:(inv_number) => <span>{inv_number}</span> 
	    },
		{
	        title: `Client`,
	        dataIndex: 'inv_client_name',
	        key: 'inv_client_name',
	        width: '22%', 	        
	        ...getColumnSearchProps('inv_client_name'),
	        sorter: true, 
	        render:(inv_client_name) => <span>{inv_client_name}</span> 
	    },
	    {
	        title: `Type`,
	        dataIndex: 'inv_type_name',
	        key: 'inv_type_name',
	        width: '15%',
	        ...getColumnSearchProps('inv_type_name'), 
	        sorter: true,
			render:(inv_type_name, record) => <div key={`type_${record.inv_id}`}>
					<div>{inv_type_name}</div>
					<div><i>{`${record.is_monthly ? record.month_year  : ''}`}</i></div>
				</div> 
	    },
		{
	        title: <div className="text-right">Amount Due</div>,
	        dataIndex: 'inv_amount_due',
	        key: 'inv_amount_due',
	        width: '12%',
	        sorter: true,
			render:(inv_amount_due) => <div className="text-right">{inv_amount_due}</div> 
	    },
		{
	        title: <div className="text-right">Created Date</div>,
	        dataIndex: 'created_at',
	        key: 'created_at',
	        width: '12%', 	        
	        sorter: true, 
	        render:(created_at) => <div className="text-right">{formatDateTimeOrNull(created_at, "YYYY-MM-DD")}</div> 
	    },
	    // {
	    //     title: `Status`,
	    //     dataIndex: 'inv_status_name',
	    //     key: 'inv_status_name',
	    //     width: '12%',
	    //     ...getColumnSearchProps('inv_status_name'), 
	    //     sorter: true,
	    // },
	    {
	        title: 'Actions',
	        dataIndex: 'inv_id',
	        key: 'inv_id',
	        width: '10%',
	        render:(inv_id) => <CrudOption baseRoute="/console/my-invoices" recordId={inv_id} allowEdit={false} allowDelete={false}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return ( <>
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      	
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.inv_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
	</>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.invoice.invoiceList?.items,
	pagination: state.invoice.invoiceList?.pagination,
	filters: state.invoice.invoiceList?.filters,
  	requesting: state.invoice.invoiceList?.requesting,
  	error: state.invoice.invoiceList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getInvoiceList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyInvoiceTable);
